<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box m-h-700">
          <div class="box-header">
            <h3 class="box-title">請輸入訂單編號</h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
              <div class="row">
                <div class="col-xs-12">
                  <div class="form-group search-bar">
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="orderSn">
                      <span class="input-group-addon c-pointer" @click="goToOneDatHistoryTable"><i class="fa fa-search"></i></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// Require needed datatables modules

export default {
  name: 'Tables',
  data () {
    return {
      orderSn: ''
    }
  },
  mounted () {
  },
  methods: {
    goToOneDatHistoryTable () {
      this.$router.push('/oneDayHistory/' + this.orderSn)
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// SearchHistory.vue?af0e8504